export default __webpack_public_path__ + "static/media/eye-black-icon.a09d0fb9.svg";